<template>
    <div class="w-full">
        <div @click="go" class="flex flex-row
            gap-3 xl:gap-4 lg:gap-3 md:gap-3">
            <div class="w-full flex flex-column flex-1 surface-50
                p-3 xl:p-4 lg:p-4 md:p-4
                border-round-2xl
                text-left cursor-pointer relative">
                <span class="flex text-600 mb-2 text-sm font-medium pr-4">
                    {{ content[lang].title }}
                </span>
                <div v-if="balance!=null" class="w-full flex flex-row mt-1">
                    <span class="flex flex-1 text-700 text-3xl font-medium white-space-nowrap">
                        {{ balance }}$
                    </span>
                    <div class="flex ml-2">
                        <Button :label="content[lang].btn_up" size="small" icon="pi pi-arrow-up" iconPos="right"
                            class="flex bg-green-100 text-green-600 border-0 border-transparent border-round-xl text-xs font-medium" />
                        <Button :label="content[lang].btn_withdraw" size="small" icon="pi pi-arrow-down" iconPos="right"
                            class="flex surface-200 text-600 border-0 border-transparent border-round-xl text-xs ml-2 font-medium" />
                    </div>
                </div>
                <Skeleton height="2rem" v-else />
                
            </div>
        </div>
    </div>
</template>


<script>
export default {
	data() {
		return {
            balance: null,
            content: {
                ru: {
                    title: 'Баланс партнера',
                    btn_up: 'Увеличить',
                    btn_withdraw: 'Вывести',
                },
                en: {
                    title: 'Partner balance',
                    btn_up: 'Increase',
                    btn_withdraw: 'Withdraw',
                },
            }
        }
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isTgApp: function () { return this.$store.getters.StateTgApp },
    },
    methods: {
        go(){
            this.$router.push({path: '/personal/partner/'})
        }
    },
    mounted() {
        this.balance = this.$store.getters.PartnerBalance
    }
}
</script>